import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from './helpers';

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot='tooltip-provider'
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root
        data-slot='tooltip'
        {...props}
      />
    </TooltipProvider>
  );
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return (
    <TooltipPrimitive.Trigger
      data-slot='tooltip-trigger'
      {...props}
    />
  );
}

function TooltipContent({
  className,
  sideOffset = 4,
  children,
  color = 'white',
  style,
  withArrow = true,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content> & { withArrow?: boolean }) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot='tooltip-content'
        sideOffset={sideOffset}
        style={{ '--tooltip-color': color, ...style } as React.CSSProperties}
        className={cn(
          'bg-[var(--tooltip-color)] text-gray-900 border border-gray-100 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-w-sm rounded-md px-3 py-1.5 text-xs shadow-[1px]',
          className
        )}
        {...props}
      >
        {children}
        {withArrow && (
          <TooltipPrimitive.Arrow className='bg-[var(--tooltip-color)] border border-gray-100  fill-[var(--tooltip-color)] -z-50 size-2.5 translate-y-[calc(-50%_-_1px)] rotate-45 rounded-[2px]' />
        )}
        <div className='absolute left-[1px] rounded-xl w-2 top-1 bottom-1 bg-[var(--tooltip-color)]' />
        <div className='absolute rounded-xl w-8 inset-x-0 h-1.5 bottom-0.5 left-1/2 -translate-x-1/2 bg-[var(--tooltip-color)]' />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
